// Điểm mở rộng của module Nhật ký cho khung ứng dụng (FSD.md §2.1).
import type { RealtimeBinding } from '@/shared/api';
import { lazyComponent, type OverlayDef } from '@/shared/lib';
import type { CreateItem } from '@/widgets/app-shell';

/** Thành phần lớp phủ nạp khi mở (chunk riêng; OverlayHost nạp trước lúc rảnh). */
const AuditSubjectOverlay = lazyComponent(() => import('./ui/overlays'), (x) => x.AuditSubjectOverlay, 'AuditSubjectOverlay');

/** Nhật ký không có mục "Tạo mới" (chỉ đọc; mục ghi từ sự kiện của các module). */
export const createItems: CreateItem[] = [];

/** ?auditSubject=<type>:<id> — "Lịch sử thao tác" của một đối tượng, mở từ mọi trang khi module Nhật ký hiển thị. */
export const overlays: OverlayDef[] = [{ key: 'auditSubject', module: 'audit', layer: 'modal', component: AuditSubjectOverlay }];

/**
 * audit-service chưa phát chủ đề thời gian thực riêng ⇒ không đăng ký binding toàn cục; trang Nhật ký tự làm mới ngày hôm
 * nay khi có tin bất kỳ (widgets/audit-table, gộp 2,5 s) và khi kênh nối lại.
 */
export const realtime: RealtimeBinding[] = [];
